// @flow
import { FormattedCurrency } from "../../../../../../components/FormattedCurrency/FormattedCurrency";

export const currencyFormatter = (value: string) => (
  <FormattedCurrency
    value={value}
    minimumFractionDigits={2}
    maximumFractionDigits={2}
    currency="USD"
  />
);

export const columns = [
  {
    name: "City",
    accessor: "location_html",
  },
  {
    name: "Rental Cost Per Sq. Ft.",
    accessor: "cost_per_sq_ft",
    formatter: currencyFormatter,
  },
];

export const rows = [
  {
    location_html: "San Francisco, CA",
    cost_per_sq_ft: 4.95,
    monthly_rental_single: 2077.96,
    yearly_income_single: 85985.38,
    monthly_rental_family: 3942.82,
    yearly_income_family: 163151.17,
  },
  {
    location_html: "New York City, NY",
    cost_per_sq_ft: 4.75,
    monthly_rental_single: 1994,
    yearly_income_single: 82511.17,
    monthly_rental_family: 3783.51,
    yearly_income_family: 156559.03,
  },
  {
    location_html: "Boston, MA",
    cost_per_sq_ft: 4.1,
    monthly_rental_single: 1721.14,
    yearly_income_single: 71220,
    monthly_rental_family: 3265.77,
    yearly_income_family: 135135.31,
  },
  {
    location_html: "Washington, D.C.",
    cost_per_sq_ft: 3.33,
    monthly_rental_single: 1397.9,
    yearly_income_single: 57670.76,
    monthly_rental_family: 2652.44,
    yearly_income_family: 109756.14,
  },
  {
    location_html: "Seattle, WA",
    cost_per_sq_ft: 3.07,
    monthly_rental_single: 1288.76,
    yearly_income_single: 53328,
    monthly_rental_family: 2445.34,
    yearly_income_family: 101186.48,
  },
  {
    location_html: "Los Angeles, CA",
    cost_per_sq_ft: 2.86,
    monthly_rental_single: 1200.6,
    yearly_income_single: 49680.41,
    monthly_rental_family: 2278.07,
    yearly_income_family: 94264.97,
  },
  {
    location_html: "Miami, FL",
    cost_per_sq_ft: 2.84,
    monthly_rental_single: 1192.2,
    yearly_income_single: 49332.83,
    monthly_rental_family: 2262.14,
    yearly_income_family: 93605.79,
  },
  {
    location_html: "Chicago, IL",
    cost_per_sq_ft: 2.49,
    monthly_rental_single: 1045.28,
    yearly_income_single: 43252.97,
    monthly_rental_family: 1983.36,
    yearly_income_family: 82070.07,
  },
  {
    location_html: "Houston, TX",
    cost_per_sq_ft: 1.49,
    monthly_rental_single: 625.49,
    yearly_income_single: 25882.34,
    monthly_rental_family: 1186.83,
    yearly_income_family: 49110.21,
  },
  {
    location_html: "Detroit, MI ",
    cost_per_sq_ft: 1.09,
    monthly_rental_single: 457.57,
    yearly_income_single: 18933.96,
    monthly_rental_family: 868.22,
    yearly_income_family: 35926.34,
  },
];
